/**
 * 모바일 디바이스 감지
 */
export const isMobileDevice = (): boolean => {
  // 2026-10-03 iOS 심사 2.1(b)(TODO_iOS 심사 §2-4) — 우리 앱(RN WebView)은 기기와 상관없이 모바일 화면이다.
  //   iPad 앱은 UA 가 Macintosh(데스크톱)이고 폭도 768 보다 넓어 PC 로 판정됐고, PC 화면엔 인앱결제가 없어
  //   구독이 카드 결제로 열렸다(«구독을 찾을 수 없다» + 외부 결제 유도 위험).
  if (typeof window !== 'undefined' && (window as any).ReactNativeWebView) return true
  // User Agent 기반 감지
  const userAgent = navigator.userAgent.toLowerCase()
  // 앱 WebView 표식(applicationNameForUserAgent) — ReactNativeWebView 가 아직 주입되기 전에도 앱으로 본다
  if (userAgent.includes('gcb-sns-session')) return true
  // iPadOS 사파리는 데스크톱 UA(Macintosh)를 보낸다 — 터치가 있으면 아이패드다(맥은 터치가 없다)
  if (userAgent.includes('macintosh') && (navigator.maxTouchPoints || 0) > 1) return true
  const mobileKeywords = ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone']
  const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword))

  // 화면 크기 기반 감지 (768px 이하를 모바일로 판단)
  const isMobileScreen = window.innerWidth <= 768

  return isMobileUA || isMobileScreen
}

/**
 * 태블릿 디바이스 감지
 */
export const isTabletDevice = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase()
  const isTabletUA = userAgent.includes('ipad') || (userAgent.includes('android') && !userAgent.includes('mobile'))
  const isTabletScreen = window.innerWidth > 768 && window.innerWidth <= 1024

  return isTabletUA || isTabletScreen
}

/**
 * 데스크톱 디바이스 감지
 */
export const isDesktopDevice = (): boolean => {
  return !isMobileDevice() && !isTabletDevice()
}

/**
 * 디바이스 타입 반환
 */
export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const getDeviceType = (): DeviceType => {
  if (isMobileDevice()) return 'mobile'
  if (isTabletDevice()) return 'tablet'
  return 'desktop'
}
